import * as tslib_1 from "tslib";
import React from 'react';
import styled from '../styles';
import classNames from 'classnames';
import isSinouiElement from '../utils/reactHelpers';
import { colorCss } from '../utils/colors';
import { BaseButtonStyle } from '../BaseButton';
import { SimpleIcon } from '../Icon';
import spacing from '../styles/spacing';
var iconStyle = {
    fontSize: 24,
    userSelect: 'none',
};
var denseStyle = {
    fontSize: 20,
    userSelect: 'none',
};
function IconButtonInner(_a) {
    var children = _a.children, _b = _a.component, Component = _b === void 0 ? 'button' : _b, dense = _a.dense, className = _a.className, rest = tslib_1.__rest(_a, ["children", "component", "dense", "className"]);
    return (React.createElement(Component, tslib_1.__assign({ role: "button", type: "button" }, rest, { className: classNames('sinoui-icon-button', className) }), React.Children.map(children, function (child) {
        if (isSinouiElement(child, ['Icon'])) {
            return (React.createElement(SimpleIcon, tslib_1.__assign({}, child.props, { style: dense ? denseStyle : iconStyle })));
        }
        else {
            return child;
        }
    })));
}
export default styled(IconButtonInner)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", ";\n  ", ";\n  width: ", "px;\n  height: ", "px;\n"], ["\n  ", ";\n  ", ";\n  width: ", "px;\n  height: ", "px;\n"])), BaseButtonStyle, colorCss, function (props) { return (props.dense ? spacing.unit * 4 : spacing.unit * 6); }, function (props) { return (props.dense ? spacing.unit * 4 : spacing.unit * 6); });
var templateObject_1;
//# sourceMappingURL=IconButtonInner.js.map